import { Box, Button, Card, CardActions, CardContent, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface SubscriptionCardLoadingProps {
	showActions: boolean;
}

const SubscriptionCardLoading = ({ showActions }: SubscriptionCardLoadingProps) => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardContent>
				<Stack gap={"5px"}>
					<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
						<Box>
							<Stack sx={{ display: "flex", flexDirection: "row" }}>
								<Typography sx={{ fontWeight: "medium", fontSize: 20, marginRight: "2px" }}>
									<Skeleton variant="text" width={150} />
								</Typography>
								<Typography sx={{ fontWeight: "medium", fontSize: 20 }}>
									<Skeleton variant="text" width={50} />
								</Typography>
							</Stack>
						</Box>
					</Stack>
					<Divider sx={{ width: "100%" }} />

					<Stack justifyContent={"flex-start"} direction={"row"} pr={1}>
						<Typography fontSize="1rem" lineHeight={1.5}>
							<Skeleton variant="text" width={200} />
						</Typography>
					</Stack>
					<Stack justifyContent={"flex-start"} direction={"row"} pr={1} alignItems={"flex-end"}>
						<Typography fontSize="1rem" lineHeight={1.5}>
							<Skeleton variant="text" width={250} />
						</Typography>
						<Typography fontSize="0.8rem">&nbsp;&nbsp;{<Skeleton variant="text" width={50} />}</Typography>
					</Stack>
					<Stack justifyContent={"flex-start"} direction={"row"} pr={1}>
						<Typography fontSize="1rem" lineHeight={1.5}>
							<Skeleton variant="text" width={150} />
						</Typography>
					</Stack>
				</Stack>
			</CardContent>
			{showActions && (
				<CardActions>
					<Button variant="contained" disabled>
						{t("subscriptionPage.change")}
					</Button>
					<Button variant="contained" disabled>
						{t("subscriptionPage.updatePaymentMethod")}
					</Button>
					<Button variant="contained" disabled>
						{t("subscriptionPage.cancelSubscription")}
					</Button>
				</CardActions>
			)}
		</Card>
	);
};

export default SubscriptionCardLoading;
